import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { setCursor } from '@parashift/shared/services';

export const cursorMetaInterceptor: HttpInterceptorFn = (req, next) =>
  next(req).pipe(
    tap(event => {
      if (!(event instanceof HttpResponse)) {
        return;
      }

      const records = (event.body as { data?: unknown })?.data;
      if (!Array.isArray(records)) {
        return;
      }
      const scope = req.params.get('sort') ?? '';

      records.forEach((record: { type?: string; id?: string; meta?: { cursor?: string } }) => {
        if (record?.type && record?.id && record.meta?.cursor) {
          setCursor(record.type, record.id, record.meta.cursor, scope);
        }
      });
    })
  );
